import { useMutation } from '@tanstack/react-query';
import { getApiUrl, handleFetchResponse } from '../shared/utils/api';

export function useRevertStatus({ token = '' }) {
  const mutation = useMutation({
    mutationKey: ['revert-status', token],
    mutationFn: async (params) => {
      const data = await handleFetchResponse(
        fetch(getApiUrl('energia-solar/v2/simulation/revert-status'), {
          method: 'POST',
          body: JSON.stringify(params),
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }),
      );
      return data;
    },
  });

  return mutation;
}
